import { useEffect } from "react";
import { IMAGES } from "../images/images"
import { Phone, Building2, Monitor, Archive, CheckCircle, Users } from "lucide-react";
import { trackPhoneConversion } from "../utils/tracking";


const PHONE = "+359876995651";
const PHONE_DISPLAY = "Обадете се";

const services = [
  { icon: Monitor, title: "Офис техника", desc: "Пренасяне и свързване на компютри, монитори, сървъри и друга офис техника с пълна грижа за безопасността." },
  { icon: Building2, title: "Мебели и обзавеждане", desc: "Разглобяване, пренасяне и сглобяване на бюра, шкафове, мебели за заседателни зали и офис обзавеждане." },
  { icon: Archive, title: "Архиви и документация", desc: "Внимателно опаковане и транспортиране на архивни материали, документация и чувствителни файлове." },
  { icon: CheckCircle, title: "Цялостна координация", desc: "Управляваме целия процес на преместване — от оглед до финалното нареждане в новия офис." },
];

const advantages = [
  "Работим извън работно време при нужда — вечер и уикенди",
  "Минимален престой на вашата дейност",
  "Опитен екип с опит в корпоративни преместванияv",
  "Специализирано опаковане на деликатна техника",
  "Фиксирана цена — договаряме се предварително",
  "Безплатен оглед и детайлна оферта",
];

export default function OfisHamaliPage() {
  useEffect(() => {
    document.title = "Преместване на офиси София | Офис хамали — Хамали София";
    const setMeta = (name, content, property = false) => {
      const attr = property ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url) => {
      let el = document.querySelector('link[rel="canonical"]');
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    setMeta("description", "Преместване на офиси в София — бюра, техника, архиви. Работим извън работно време за минимален престой на дейността. Безплатен оглед. Обадете се: +359 876 995 651");
    setMeta("og:title", "Преместване на офиси София | Офис хамали — Хамали София", true);
    setMeta("og:description", "Бързо и сигурно преместване на офис оборудване, мебели и техника в София. Работим вечер и уикенди. Минимален престой за вашия бизнес.", true);
    setMeta("og:url", "https://hamalski-sofia.com/ofis-hamali", true);
    setCanonical("https://hamalski-sofia.com/ofis-hamali");
  }, []);

  return (
    <div style={{ backgroundColor: "#FFFFFF", paddingTop: "68px" }}>

      {/* HERO — dark */}
      <section data-testid="ofis-hero" style={{ position: "relative", minHeight: "70vh", display: "flex", alignItems: "center", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${IMAGES.OficeHero})`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="hero-overlay" />
        <div style={{ position: "relative", zIndex: 2, maxWidth: "1280px", margin: "0 auto", padding: "4rem 1.25rem", width: "100%" }}>
          <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "1rem" }}>Преместване на офиси — София</p>
          <h1 data-testid="ofis-h1" style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(2.25rem, 6vw, 4.5rem)", lineHeight: 1.05, letterSpacing: "-0.02em", color: "#FFFFFF", textTransform: "uppercase", maxWidth: "700px", marginBottom: "1.5rem" }}>
            Бързо и Сигурно{" "}
            <span style={{ color: "#2dcf0c" }}>Преместване на Офиси</span>
          </h1>
          <p style={{ color: "#d4d4d8", fontSize: "1.05rem", lineHeight: 1.7, maxWidth: "560px", marginBottom: "2rem" }}>
            Специализирани услуги за преместване на бизнеси и офиси в София. Минимален престой — максимална ефективност.
          </p>
          <a href={`tel:${PHONE}`} data-testid="ofis-call-btn" className="btn-call" style={{ padding: "1rem 2.25rem", fontSize: "1rem", borderRadius: "4px" }} onClick={trackPhoneConversion}>
            <Phone size={20} />
            <span>{PHONE_DISPLAY}</span>
          </a>
        </div>
      </section>

      {/* B2B MESSAGE — white */}
      <section style={{ padding: "4rem 1.25rem" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "3rem", alignItems: "center" }}>
          <div>
            <p style={{ color: "#2dcf0c", fontSize: "0.8rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "0.75rem" }}>За бизнеса</p>
            <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.5rem, 3vw, 2.25rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "1.5rem" }}>
              Преместване без <span style={{ color: "#2dcf0c" }}>прекъсване</span>
            </h2>
            <p style={{ color: "#374151", fontSize: "0.975rem", lineHeight: 1.8, marginBottom: "1.5rem" }}>
              Разбираме, че всяко преместване на офис означава временно спиране на бизнес процесите. Затова планираме задълбочено и работим бързо — така вашият бизнес губи минимално работно време.
            </p>
            <p style={{ color: "#6B7280", fontSize: "0.925rem", lineHeight: 1.8 }}>
              Опитният ни екип може да работи вечер или през уикенда, за да осигури пълна готовност на новото ви работно място.
            </p>
          </div>
          <div>
            <div style={{ padding: "2rem", backgroundColor: "#F8F8FA", border: "1px solid rgba(45,207,12,0.2)", borderRadius: "8px", boxShadow: "0 2px 16px rgba(0,0,0,0.05)" }}>
              <h3 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 800, fontSize: "1rem", color: "#2dcf0c", textTransform: "uppercase", marginBottom: "1.25rem" }}>Нашите предимства</h3>
              <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: "0.75rem" }}>
                {advantages.map((a, i) => (
                  <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: "0.625rem", color: "#374151", fontSize: "0.875rem", lineHeight: 1.6 }}>
                    <CheckCircle size={16} color="#2dcf0c" style={{ marginTop: "2px", flexShrink: 0 }} />
                    {a}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES GRID — light grey */}
      <section data-testid="ofis-services" style={{ backgroundColor: "#F8F8FA", borderTop: "1px solid rgba(0,0,0,0.06)", padding: "4rem 1.25rem" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
          <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.5rem, 3vw, 2.25rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", textAlign: "center", marginBottom: "3rem" }}>
            Какво включва <span style={{ color: "#2dcf0c" }}>Услугата</span>
          </h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "1.25rem" }}>
            {services.map((s) => {
              const Icon = s.icon;
              return (
                <div key={s.title} data-testid={`ofis-service-${s.title.toLowerCase().replace(/\s+/g, '-')}`}
                  style={{ padding: "2rem", backgroundColor: "#FFFFFF", border: "1px solid rgba(0,0,0,0.08)", borderRadius: "8px", boxShadow: "0 2px 16px rgba(0,0,0,0.05)", transition: "box-shadow 0.25s ease, border-color 0.25s ease" }}
                  onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 24px rgba(45,207,12,0.12)"; e.currentTarget.style.borderColor = "rgba(45,207,12,0.3)"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 2px 16px rgba(0,0,0,0.05)"; e.currentTarget.style.borderColor = "rgba(0,0,0,0.08)"; }}>
                  <div style={{ width: 48, height: 48, backgroundColor: "rgba(45,207,12,0.08)", border: "1px solid rgba(45,207,12,0.2)", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "1.25rem" }}>
                    <Icon size={22} color="#2dcf0c" />
                  </div>
                  <h3 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 800, fontSize: "1rem", color: "#0A0A0A", textTransform: "uppercase", marginBottom: "0.625rem" }}>{s.title}</h3>
                  <p style={{ color: "#6B7280", fontSize: "0.875rem", lineHeight: 1.65 }}>{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* PROCESS — white */}
      <section data-testid="ofis-process" style={{ padding: "4rem 1.25rem", maxWidth: "1280px", margin: "0 auto" }}>
        <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.5rem, 3vw, 2rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", textAlign: "center", marginBottom: "3rem" }}>
          Как протича преместването
        </h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "1px", backgroundColor: "rgba(0,0,0,0.06)" }}>
          {[
            { num: "01", label: "Запитване", desc: "Обаждате се и описвате обема на преместването." },
            { num: "02", label: "Оглед", desc: "Специалист посещава офиса за детайлна оценка." },
            { num: "03", label: "Планиране", desc: "Съставяме детайлен план за минимален престой." },
            { num: "04", label: "Изпълнение", desc: "Преместваме всичко бързо и внимателно." },
          ].map((s) => (
            <div key={s.num} style={{ padding: "2rem 1.5rem", textAlign: "center", backgroundColor: "#FFFFFF" }}>
              <div style={{ fontSize: "2.75rem", fontFamily: "Montserrat, sans-serif", fontWeight: 900, color: "rgba(45,207,12,0.35)", marginBottom: "0.5rem" }}>{s.num}</div>
              <h3 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 800, fontSize: "0.95rem", color: "#0A0A0A", textTransform: "uppercase", marginBottom: "0.5rem" }}>{s.label}</h3>
              <p style={{ color: "#6B7280", fontSize: "0.85rem", lineHeight: 1.65 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section data-testid="ofis-cta" style={{ padding: "4rem 1.25rem", textAlign: "center", backgroundColor: "#F0FDF4", borderTop: "1px solid rgba(45,207,12,0.2)" }}>
        <div style={{ maxWidth: "700px", margin: "0 auto" }}>
          <Users size={40} color="#2dcf0c" style={{ marginBottom: "1rem" }} />
          <h2 style={{ fontFamily: "Montserrat, sans-serif", fontWeight: 900, fontSize: "clamp(1.5rem, 3.5vw, 2.5rem)", color: "#0A0A0A", textTransform: "uppercase", letterSpacing: "-0.02em", marginBottom: "1rem" }}>
            Преместваме вашия офис <span style={{ color: "#2dcf0c" }}>бързо и без стрес!</span>
          </h2>
          <p style={{ color: "#6B7280", marginBottom: "2rem", fontSize: "1rem" }}>Свържете се с нас за безплатен оглед и оферта за преместване на офис в София.</p>
          <a href={`tel:${PHONE}`} data-testid="ofis-cta-btn" className="btn-call" style={{ padding: "1.1rem 2.5rem", fontSize: "1.1rem", borderRadius: "4px" }} onClick={trackPhoneConversion}>
            <Phone size={22} />
            <span>{PHONE_DISPLAY}</span>
          </a>
        </div>
      </section>
    </div>
  );
}
